import { PageTreeFilterValues } from '@/declarations/PageTreeFilterValues';

export const hasNarrowingFilter = (filterValues: PageTreeFilterValues): boolean =>
  Boolean(
    filterValues.query ||
      filterValues.statuses.length ||
      filterValues.main_category ||
      filterValues.sub_categories.length ||
      filterValues.lastEditedPagesView,
  );
